import Vue from 'vue';
import Router, { Route } from 'vue-router';
import navigationGuards from '@/navigationGuards';
import { notificationService } from './services/notification-service';
import { Product, ProductsApi, Tank, TanksApi } from '@/api';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		/*{
      path: '/',
      name: 'home',
      component: Home,
    },*/
		{
			path: '/',
			name: 'home',
			component: () => import('./pages/search/search.vue'),
			meta: { auth: true },
		},
		{
			path: '/auth/login',
			name: 'auth.login',
			component: () => import('./pages/auth/login.vue'),
			meta: { layout: 'AppLayoutLogin' },
		},
		{
			path: '/auth/forgot',
			name: 'auth.forgot',
			component: () => import('./pages/auth/forgot.vue'),
			meta: { layout: 'AppLayoutLogin' },
		},
		{
			path: '/auth/reset/:token',
			name: 'auth.reset',
			component: () => import('./pages/auth/reset.vue'),
			meta: { layout: 'AppLayoutLogin' },
		},
		{
			path: '/auth/changeEmail/:token',
			name: 'auth.changeEmail',
			component: () => import('./pages/auth/emailchange.vue'),
			meta: { layout: 'AppLayoutLogin' },
		},
		{
			path: '/account/organisations',
			name: 'organisations.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/list.vue'),
			meta: { auth: true },
			// restrict access to admin
			// meta: {auth: {roles: 'admin', redirect: {name: 'auth.login'}, forbiddenRedirect: '/403'}},
		},
		{
			path: '/account/organisations/addOrg',
			name: 'organisations.addOrg',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/addOrg.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/organisations/parent',
			name: 'organisations.parent',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/parent.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/organisations/edit/:orgId',
			name: 'organisations.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/organisations/editbilling/:orgId',
			name: 'organisations.editbilling',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/editbilling.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/organisations/:orgId',
			name: 'organisations.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/organisations/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products',
			name: 'products.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/list.vue'),
			meta: { auth: true, title: 'Products' },
		},
		{
			path: '/account/products/effluent/:productId',
			name: 'products.effluent.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/effluent/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/:productId',
			name: 'products.view',
			meta: { auth: true },
		},
		{
			path: '/account/products/effluent/:productId/edit',
			name: 'products.effluent.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/effluent/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/milk/:productId',
			name: 'products.milk.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/view.vue'),
			meta: { auth: true, title: 'Products', showJob: false },
		},
		{
			path: '/account/products/milk/:productId/vat/:vatId',
			name: 'products.milk.vat',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/view.vue'),
			meta: { auth: true },
			props: true,
		},
		{
			path: '/account/products/milk/:productId/vats',
			name: 'products.milk.vats',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/vats/vats.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/milk/:productId/vatsswap',
			name: 'products.milk.vatsswap',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/vats/vatsswap.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/milk/:productId/sensors',
			name: 'products.milk.sensorAssignment',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/vats/create.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/milk/:productId/assign',
			name: 'products.milk.assign',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/vats/assign.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/milk/:productId/edit',
			name: 'products.milk.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/milk/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/add',
			name: 'products.add',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/addProduct.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/fuel/tank/list',
			name: 'products.fuel.tank.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/tanks/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/fuel/tank/:tankId',
			name: 'entity.tank.view',
			meta: { auth: true },
		},
		{
			path: '/account/products/fuel/:productId',
			name: 'products.fuel.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/fuel/:productId/tank/:tankId',
			name: 'products.fuel.tank.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/fuel/:productId/edit',
			name: 'products.fuel.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/list',
			name: 'products.water.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/water/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/:productId',
			name: 'products.water.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/water/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/:productId/:entityType/:entityId',
			name: 'products.water.entity.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/water/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/:productId/edit',
			name: 'products.water.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/water/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/tank/list',
			name: 'products.water.tank.list',
			component: () =>
				import(
					/* webpackChunkName: "account" */ './pages/account/products/water/entity/tankList.vue'
				),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/meter/list',
			name: 'products.water.meter.list',
			component: () =>
				import(
					/* webpackChunkName: "account" */ './pages/account/products/water/entity/meterList.vue'
				),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/monitor/list',
			name: 'products.water.monitor.list',
			component: () =>
				import(
					/* webpackChunkName: "account" */ './pages/account/products/water/entity/monitorList.vue'
				),
			meta: { auth: true },
		},
		{
			path: '/account/products/water/exports/list',
			name: 'products.water.exports.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/water/exports/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/products/feed/:productId',
			name: 'products.feed.view',
			component: () =>
				import(
					/* webpackChunkName: "account" */ './pages/account/products/feed/FeedProductDetailPage.vue'
				),
			meta: { auth: true },
			redirect: { name: 'products.feed.general.information' },
			children: [
				{
					path: 'general',
					name: 'products.feed.general',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/general/FeedProductGeneralTab.vue'
						),
					redirect: { name: 'products.feed.general.information' },
					children: [
						{
							path: 'information',
							name: 'products.feed.general.information',
							component: () =>
								import(
									/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/general/FeedProductInformation.vue'
								),
						},
						{
							path: 'audits',
							name: 'products.feed.general.audits',
							component: () =>
								import(
									/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/general/FeedProductAuditLog.vue'
								),
						},
						{
							path: 'billing/audits',
							name: 'products.feed.general.subscription.audits',
							component: () =>
								import(
									'./pages/account/products/feed/components/tabs/general/FeedProductBillingAuditLog.vue'
								),
						},
					],
				},
				{
					path: 'partnerorgs',
					name: 'products.feed.partnerorgs',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/partner-orgs/FeedProductPartnerOrgsTab.vue'
						),
				},
				{
					path: 'feedtanks',
					name: 'products.feed.feedtanks',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTanksTab.vue'
						),
					redirect: { name: 'products.feed.feedtanks.overview' },
					children: [
						{
							path: 'overview',
							name: 'products.feed.feedtanks.overview',
							component: () =>
								import(
									/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTanksOverview.vue'
								),
						},
						{
							path: ':feedTankId',
							name: 'products.feed.feedtanks.tankdetail',
							component: () =>
								import(
									/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTankDetail.vue'
								),
							props: true,
							redirect: { name: 'products.feed.feedtanks.tankdetail.general' },
							children: [
								{
									path: 'general',
									name: 'products.feed.feedtanks.tankdetail.general',
									component: () =>
										import(
											/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTankGeneralSection.vue'
										),
								},
								{
									path: 'corrections',
									name: 'products.feed.feedtanks.tankdetail.corrections',
									component: () =>
										import(
											/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTankCorrections.vue'
										),
								},
								{
									path: 'charts',
									name: 'products.feed.feedtanks.tankdetail.charts',
									component: () =>
										import(
											/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTankCharts.vue'
										),
								},
								{
									path: 'alerts',
									name: 'products.feed.feedtanks.tankdetail.alerts',
									component: () =>
										import(
											/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/feed-tanks/FeedTankAlertsSection.vue'
										),
								},
							],
						},
					],
				},
				{
					path: 'map',
					name: 'products.feed.map',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductMapTab.vue'
						),
				},
				{
					path: 'transceivers',
					name: 'products.feed.transceivers',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductTransceiversTab.vue'
						),
				},
				{
					path: 'users',
					name: 'products.feed.users',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductUsersTab.vue'
						),
				},
				{
					path: 'simprojobs',
					name: 'products.feed.simprojobs',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductSimproJobsTab.vue'
						),
				},
				{
					path: 'faults',
					name: 'products.feed.faults',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductFaultsTab.vue'
						),
				},
				{
					path: 'repairjobtexts',
					name: 'products.feed.repairjobtexts',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductRepairJobTextsTab.vue'
						),
				},
				{
					path: 'smscharges',
					name: 'products.feed.smscharges',
					component: () =>
						import(
							/* webpackChunkName: "account" */ './pages/account/products/feed/components/tabs/FeedProductSMSChargesTab.vue'
						),
				},
			],
		},
		{
			path: '/account/products/feed/:productId/edit',
			name: 'products.feed.edit',
			component: () =>
				import(
					/* webpackChunkName: "account" */ './pages/account/products/feed/EditFeedProductPage.vue'
				),
			meta: { auth: true },
			props: true,
		},
		{
			path: '/account/sites',
			name: 'sites.list',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/sites/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/sites/add',
			name: 'sites.add',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/sites/add.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/sites/view/:siteId',
			name: 'sites.view',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/sites/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/sites/edit/:siteId',
			name: 'sites.edit',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/sites/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/users',
			name: 'users.list',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/users/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/users/view/:userId',
			name: 'users.view',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/users/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/users/permission/:userId',
			name: 'users.permission',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/users/permission.vue'),
			meta: { auth: true },
		},
		{
			path: '/account/users/edit/:userId',
			name: 'users.edit',
			component: () => import(/* webpackChunkName: "account" */ './pages/account/users/edit.vue'),
			meta: { auth: true },
		},
		{
			path: '/issues/faults',
			name: 'faults.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/issue-tracking/faults/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/issues/exports',
			name: 'exports.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/issue-tracking/exports/view.vue'),
			meta: { auth: true, requiredRoles: ['reports', 'super'] },
		},
		{
			path: '/issues/escalatedAlerts',
			name: 'escalatedAlerts',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/issue-tracking/escalatedAlerts/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/issues/faults/:productId',
			name: 'faults.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/issue-tracking/faults/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/sensors',
			name: 'sensors.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/sensors/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/sensors/add',
			name: 'sensors.add',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/sensors/add.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/sensors/:sensorId',
			name: 'sensors.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/sensors/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/transceivers',
			name: 'transceivers.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/transceivers/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/transceivers/add',
			name: 'transceivers.add',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/transceivers/add.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/transceivers/:transceiverId',
			name: 'transceivers.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/transceivers/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/simCards',
			name: 'simCards.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/sim-cards/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/simCards/:simId',
			name: 'simCards.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/sim-cards/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/gateways/:gatewayId',
			name: 'gateways.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/gateways/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/gateways',
			name: 'gateways.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/gateways/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/nodes/:nodeId',
			name: 'nodes.view',
			component: () => import(/* webpackChunkName: "account" */ './pages/inventory/nodes/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/nodes',
			name: 'nodes.list',
			component: () => import(/* webpackChunkName: "account" */ './pages/inventory/nodes/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/accessories',
			name: 'accessories.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/accessories/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/accessories/:accessoryId',
			name: 'accessories.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/accessories/view.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/thing-groups',
			name: 'thing-groups.manage',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/thing-groups/manage.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/thing-groups-list',
			name: 'thing-groups.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/thing-groups/list.vue'),
			meta: { auth: true },
		},
		{
			path: '/inventory/thing-groups/add',
			name: 'thing-groups.add',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/thing-groups/add.vue'),
			meta: { auth: true, requiredRoles: ['super', 'development'] },
		},
		{
			path: '/inventory/thing-groups/edit/:thingGroupName',
			name: 'thing-groups.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/inventory/thing-groups/edit.vue'),
			meta: { auth: true, requiredRoles: ['super', 'development'] },
		},
		{
			path: '/account/products/fuel/formulas/list',
			name: 'formulas.list',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/formulas/list.vue'),
			meta: { auth: true, requiredRoles: ['super', 'formulas'] },
		},
		{
			path: '/account/products/fuel/formulas/add',
			name: 'formulas.add',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/formulas/add.vue'),
			meta: { auth: true, requiredRoles: ['super', 'formulas'] },
		},
		{
			path: '/accounts/products/fuel/formulas/edit/:formulaId',
			name: 'formulas.edit',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/formulas/edit.vue'),
			meta: { auth: true, requiredRoles: ['super', 'formulas'] },
		},
		{
			path: '/account/products/fuel/formulas/:formulaId',
			name: 'formulas.view',
			component: () =>
				import(/* webpackChunkName: "account" */ './pages/account/products/fuel/formulas/view.vue'),
			meta: { auth: true, requiredRoles: ['super', 'formulas'] },
		},
		{
			path: '*',
			redirect: '/',
		},
	],
});

router.beforeEach((to, from, next) => {
	if ((to.redirectedFrom ?? to.fullPath)?.startsWith('/#/')) {
		next((to.redirectedFrom ?? to.fullPath)?.substr('/#'.length));
		return;
	}
	next();
});

router.beforeEach(async (to, from, next) => {
	const token = localStorage.getItem('user-token');
	const requiresAuth = to.matched.some(record => record.meta.auth);
	if (requiresAuth && !token) {
		next({ name: 'auth.login', query: { from: to.path } });
	} else {
		if (to.meta.requiredRoles) {
			await navigationGuards.permissionGuard(to, from, next);
		} else {
			next();
		}
	}
});

router.beforeEach(async (to, from, next) => {
	if (to.name === 'products.view' && 'productId' in to.params) {
		let productId: string | number = to.params['productId'];
		try {
			productId = parseInt(productId);
			const product: Product = (await new ProductsApi().getProductById(productId))?.data;
			if (product) {
				next({ name: `products.${product.type}.view`, params: to.params });
				return;
			}
		} catch (e) {}
		next('/');
		return;
	} else if (to.name === 'entity.tank.view' && 'tankId' in to.params) {
		let tankId: string | number = to.params['tankId'];
		try {
			tankId = parseInt(tankId);
			const tank: Tank = <Tank>(await new TanksApi().getTankById(tankId))?.data;
			if (tank?.productId) {
				next({
					name: `products.fuel.tank.view`,
					params: {
						...to.params,
						productId: `${tank.productId}`,
					},
				});
				return;
			}
		} catch (e) {
			console.log(e);
		}
		next('/');
		return;
	}
	next();
});

router.afterEach((to: Route) => {
	if (to.meta.auth && localStorage.getItem('user-token')) {
		notificationService.fetchEventNotifications();
	}
});

export default router;
